import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';

const styles = (theme) => {
    return {
        root: {
            position: 'absolute',
            right: 0,
            top: 48 - 12,
            backgroundColor: theme.palette.common.transparent,
            textAlign: 'left',
            zIndex: 200,
        },
        arrowContainer: {
            position: 'relative',
            marginRight: 0,
        },
        arrowBorder: {
            position: 'relative',
            marginTop: 0,
            marginRight: 0,
            marginLeft: 'auto',
            width: 0,
            height: 0,
            borderLeftWidth: 7,
            borderLeftStyle: 'solid',
            borderLeftColor: theme.palette.common.transparent,
            borderRightWidth: 7,
            borderRightStyle: 'solid',
            borderRightColor: theme.palette.common.transparent,
            borderBottomWidth: 7,
            borderBottomStyle: 'solid',
            borderBottomColor: theme.palette.primary.lightBorder,
            backgroundColor: theme.palette.common.transparent,
            zIndex: 1,
        },
        arrow: {
            position: 'absolute',
            top: 1,
            right: 1,
            width: 0,
            height: 0,
            borderLeftWidth: 6,
            borderLeftStyle: 'solid',
            borderLeftColor: theme.palette.common.transparent,
            borderRightWidth: 6,
            borderRightStyle: 'solid',
            borderRightColor: theme.palette.common.transparent,
            borderBottomWidth: 6,
            borderBottomStyle: 'solid',
            borderBottomColor: theme.palette.primary.light,
            backgroundColor: theme.palette.common.transparent,
            zIndex: 2,
        },
        container: {
            position: 'relative',
            marginTop: -1,
            borderColor: theme.palette.primary.lightBorder,
            borderWidth: 1,
            borderStyle: 'solid',
            backgroundColor: theme.palette.primary.light,
            zIndex: 0,
        },
    };
}

class Popover extends Component {
    constructor(props) {
        super(props);

        this._refMap = {
            popover: React.createRef(),
        };
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.props.open !== nextProps.open);
    }

    render = () =>{
        if (!this.props.open) {
            document.removeEventListener('click', this._handleClose);
            return null;
        } else {
            document.addEventListener('click', this._handleClose);
        }

        const {classes} = this.props;

        return (
            <div
                className={classes.root}
                ref={this._refMap.popover}
            >
                <div className={classNames(classes.arrowContainer, this.props.className)}>
                    <div className={classes.arrowBorder}/>
                    <div className={classes.arrow}/>
                </div>
                <div  className={classes.container}>
                    {this.props.children}
                </div>
            </div>
        );
    }

    _handleClose = (e) => {
        e.preventDefault();

        if (e && this._refMap.popover.current.contains(e.target)) {
            return;
        }

        if (this.props.onClose) {
            this.props.onClose(e);
        }
    }
}

Popover.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func
}

export default withStyles(styles)(Popover);
